import React, { useEffect, useState } from "react";

const OFFERS = [
  // 🎮 Mobile Games
  "500 Free Fire diamonds",
  "100 Roblox coins",
  "Stumble Guys skins",
  "Minecraft Premium Skins",
  "Genshin Impact Primogems",
  "Among Us Crewmate Skins",
  "Clash of Clans Gems",
  "PUBG Mobile UC 300",
  "Brawl Stars Coins",
  "Call of Duty Mobile CP",
  "Fortnite V-Bucks 500",
  "Coin Master Spins 100",
  "Pokemon Go Lucky Eggs",
  "Roblox Premium 30 Days",
  "Free Fire Elite Pass",

  // 💳 Gift Cards
  "$5 Amazon Gift Card",
  "$10 Amazon Gift Card",
  "$20 Amazon Gift Card",
  "$10 Google Play Gift Card",
  "$10 iTunes Gift Card",
  "$5 Steam Gift Card",
  "$10 Steam Gift Card",
  "$25 Xbox Gift Card",
  "$25 PlayStation Gift Card",
  "$50 Walmart Gift Card",
  "$10 Target Gift Card",
  "$10 Starbucks Gift Card",

  // 🛡️ Apps & Tools
  "NordVPN 30-day trial",
  "Surfshark VPN 30-day trial",
  "ExpressVPN 7-day trial",
  "LastPass Premium 1-month trial",
  "Grammarly Premium 1-month trial",
  "Canva Pro Free Trial",
  "Spotify Premium 1-month trial",
  "Audible 30-day trial",
  "Duolingo Plus 1-month trial",
  "Notion Premium Free Trial",
  "Adobe Creative Cloud 7-day trial",

  // 💰 Finance / Crypto
  "Coinbase $10 Free Crypto",
  "Binance $15 Free Crypto",
  "Cash App $5 Signup Bonus",
  "Revolut Free Account Signup",
  "Chime $10 Signup Bonus",
  "BlockFi $25 Free Crypto",
  "Crypto.com $25 Signup Bonus",
  "Kraken $10 Signup Reward",

  // 📚 Guides / eBooks / Cheats
  "Free Clash of Clans Strategy Guide",
  "Roblox Building Guide PDF",
  "Free Fortnite Tips & Tricks PDF",
  "Free Crypto Trading Guide",
  "Free Side Hustle PDF Guide",
  "Free Minecraft Building Guide",
  "Free Mobile Gaming Cheats PDF",
  "Free Roblox Script Cheat",

  // 🎁 Sweepstakes / SOI Offers
  "Win an iPhone 15",
  "Win a PS5 Console",
  "Win $100 PayPal Cash",
  "Win a $50 Amazon Gift Card",
  "Win a Nintendo Switch",
  "Win a Samsung Galaxy Phone",
  "Enter CashApp Giveaway",
  "Enter Fortnite V-Bucks Giveaway"
];


const LiveTicker = () => {
  const [messages, setMessages] = useState([]);
  

 
  useEffect(() => {
     // Fallback ID generator for mobile browsers
  const generateId = () => {
    return Math.random().toString(36).substring(2, 10) + Date.now().toString(36);
  };

  // Fetch random names from Random User API
  const fetchRandomUsers = async () => {
    try {
      const res = await fetch(`https://randomuser.me/api/?results=${10}&nat=us`);
      const data = await res.json();
      const newMessages = data.results.map((user) => {
        const name = `${user.name.first} ${user.name.last}.`;
        const offer = OFFERS[Math.floor(Math.random() * OFFERS.length)];
        return {
          id: generateId(), // use fallback ID generator
          text: `${name} just claimed ${offer}!`,
        };
      });
      setMessages(newMessages);
    } catch (err) {
      console.error("Error fetching random users:", err);
    }
  };
    fetchRandomUsers();
  },[]);

  return (
    <div className="w-full bg-[#1a1a1a] py-2 border-b border-gray-800 ticker-wrap relative overflow-hidden">
      <div className="ticker-content flex gap-8 px-4 whitespace-nowrap animate-marquee">
        {messages.concat(messages).map((msg,idx) => (
          <span
            key={`${msg.id}-${idx}`}
            className="text-xs text-gray-400 font-medium whitespace-nowrap"
          >
            {msg.text}
          </span>
        ))}
      </div>

      {/* Optional marquee animation */}
      <style>
        {`
          .animate-marquee {
            display: inline-flex;
            animation: marquee 100s linear infinite;
          }
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}
      </style>
    </div>
  );
};

export default LiveTicker;
